import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { Hero } from '@/components/home/Hero';
import { IntroSection } from '@/components/home/IntroSection';
import { ServicesSection } from '@/components/home/ServicesSection';
import { AssetClassCards } from '@/components/home/AssetClassCards';
import { ProcessSteps } from '@/components/home/ProcessSteps';
import { ToolsTeaser } from '@/components/home/ToolsTeaser';
import { BuyerGroups } from '@/components/home/BuyerGroups';
import { TrustSection } from '@/components/home/TrustSection';
import { Testimonials } from '@/components/home/Testimonials';
import { FAQ } from '@/components/home/FAQ';
import { CTAFooter } from '@/components/home/CTAFooter';
import { BlogTeaser } from '@/components/home/BlogTeaser';
import { OrganizationSchema } from '@/components/schema/OrganizationSchema';
import { LocalBusinessSchema } from '@/components/schema/LocalBusinessSchema';
import { ReviewSchema } from '@/components/schema/ReviewSchema';

export const Home = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <OrganizationSchema />
      <LocalBusinessSchema />
      <ReviewSchema />
      <SEO
        title="RetailInvest – Ihr Makler für Handelsimmobilien in Deutschland"
        description="Professionelle Vermittlung von Handelsimmobilien: Lebensmittelmärkte, Fachmärkte, Fachmarktzentren. WAULT-Rechner kostenlos, strukturierter Verkaufsprozess, bundesweit tätig."
        url="/"
      />
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <IntroSection />
        <ServicesSection />
        <AssetClassCards />
        <ProcessSteps />
        <ToolsTeaser />
        <BuyerGroups />
        <TrustSection />
        <Testimonials />
        <FAQ />
        <BlogTeaser />
        <CTAFooter />
      </main>
      <Footer />
    </div>
  );
};

export default Home;